// extracted by css-extract-rspack-plugin
export default {"body":"eKOZFboJ8Hw8CmSG","form":"sYxQ30z1GUsF46JK","modeActions":"v3o4lKcSSAmBNoc_","helpText":"gYMySJimS0AMLLRG"};